import { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { LuDownload, LuPrinter } from "react-icons/lu";

import { useTranslation } from "react-i18next";
import { FaFilePdf, FaPrint } from "react-icons/fa";
import i18next from "i18next";
import { useCurrent, useFetch, usePost } from "../../../hooks";
import MwCardWrapper from "../../ui/MwCardWrapper";
import {
  MwInputText,
  MwSelector,
  MwSpinnerButton,
  NoDataFound,
  TagList,
} from "../../ui";
import { NewButton } from "../../ui/NewButton";
import SalesReportsList from "../SalesReportsList";
import ExpensesReportsList from "./ExpensesReportsList";

const ExpensesReport = () => {
  const divPrintRef = useRef();
  const [t] = useTranslation("global");
  const { currentLangId, currentTenantId, currentCompanyId, currentBranchId } =
    useCurrent();
  const { data: expenses, loading: loadingexpenses } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/expenses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const { data: vendorsResult } = useFetch(
    `${process.env.REACT_APP_VENDORS_API_SERVER_BASE_URL}/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const [vendorsList, setvendorsResultList] = useState([]);
  const [Taglist, setTaglist] = useState([]);
  const [errors, setErrors] = useState([]);
  useEffect(() => {
    console.log(vendorsResult);
  }, []);
  useEffect(() => {
    if (vendorsResult) {
      const _list = [
        {
          label: currentLangId === "ar" ? "الكل" : "All",
          value: "",
          lang: currentLangId,
        },
        ...vendorsResult?.data?.map((item) => {
          const nameObj = item.fullname.find(
            (name) => name.lang === currentLangId
          );
          return {
            label: nameObj?.text || "Unnamed Vendor",
            value: item._id,
            lang: currentLangId,
          };
        }),
      ];

      console.log("Treasuries List:", _list);
      console.log("vendor List:", vendorsResult);
      setvendorsResultList(_list);
    }
  }, [vendorsResult, currentLangId]);

  const {
    data: filterDataResult,
    loading: filterLoading,
    postData,
  } = usePost();
  const getDefaultDates = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
      .toISOString()
      .split("T")[0];
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      .toISOString()
      .split("T")[0];

    return { firstDay, lastDay };
  };

  const [expensesFormState, setexpensesFormState] = useState({
    tags: [],
    vendor_id: "",
    start_date: getDefaultDates().firstDay,
    end_date: getDefaultDates().lastDay,
    seller_name: "",
    created_by: "",
  });
  useEffect(() => {
    setexpensesFormState((prevState) => ({
      ...prevState,
      start_date: getDefaultDates().firstDay,
      end_date: getDefaultDates().lastDay,
    }));
  }, []);

  const formatDate = (date) =>
    date ? new Date(date).toISOString().split("T")[0] : "";
  const submitHandler = (e) => {
    e.preventDefault();
    let errorobj = {};
    if (!expensesFormState?.start_date) {
      errorobj = { ...errorobj, start_date: "start date is required" };
    }
    if (!expensesFormState?.end_date) {
      errorobj = { ...errorobj, end_date: "end date is required" };
    }

    if (Object.keys(errorobj).length !== 0) {
      setErrors(errorobj);
      return;
    }
    const _data = {
      tags: expensesFormState.tags || [],
      vendor_id: expensesFormState.vendor_id?.value || "",
      start_date: formatDate(expensesFormState.start_date) || "",
      end_date: formatDate(expensesFormState.end_date) || "",
      seller_name: expensesFormState.seller_name || "",
      created_by: expensesFormState.created_by || "",
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    postData(
      `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/expenses/filterBy`,
      _data
    );
  };

  const printHandler = () => {
    if (divPrintRef.current && divPrintRef.current.innerHTML.trim() !== "") {
      window.print();
    }
  };

  const exportExcel = () => {
    if (filterDataResult?.data) {
      const formattedData = filterDataResult.data.map((item) => [
        item.code,
        item.desc || "لا يوجد",
        item.expenses_date,
        item.total_amount,
        getTaxLabel(item.details[0]?.tax_type),
      ]);

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet([
        [
          t("Salaries.BondNumber"),
          t("Salaries.bondDescription"),
          t("Salaries.BondDate"),
          t("Salaries.BondAmount"),
          t("Salaries.Vat"),
        ],
        ...formattedData,
      ]);

      ws["!cols"] = [
        { wch: 15 },
        { wch: 30 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
      ];

      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell) {
            cell.s = {
              alignment: { horizontal: "center", vertical: "center" },
              font: R === 0 ? { bold: true } : {},
            };
          }
        }
      }

      XLSX.utils.book_append_sheet(wb, ws, t("reports.bonds_reports"));
      XLSX.writeFile(wb, `${t("reports.bonds_reports")}.xlsx`);
    }
  };
  const exportPDF = async () => {
    const input = divPrintRef.current;
    if (!input) return;

    const canvas = await html2canvas(input, {
      scale: 3,
      useCORS: true,
      scrollY: -window.scrollY,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth(); // 210mm
    const pdfHeight = pdf.internal.pageSize.getHeight(); // 297mm

    const imgProps = pdf.getImageProperties(imgData);

    const margin = 5;
    const imgWidth = pdfWidth - margin * 2;
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

    let heightLeft = imgHeight;
    let position = margin;

    pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight - margin * 2;

    while (heightLeft > 0) {
      pdf.addPage();
      position = margin;
      heightLeft -= pdfHeight - margin * 2;

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        position - heightLeft,
        imgWidth,
        imgHeight
      );
    }

    pdf.save(`${t("reports.bonds_reports")}.pdf`);
  };
  const getTaxLabel = (taxType, lang = i18next.language) => {
    const taxTypes = {
      ar: {
        "VAT-15": "ضريبة 15%",
        ZERO: "ضريبة صفرية",
        EXEMPT: "معفى من الضريبة",
      },
      en: {
        "VAT-15": "VAT 15%",
        ZERO: "Zero Tax",
        EXEMPT: "Tax Exempt",
      },
    };

    return (
      taxTypes[lang]?.[taxType] ||
      (lang === "ar" ? "غير محدد" : "Not specified")
    );
  };

  return (
    <>
      <div className="border overflow-y-auto h-[calc(85vh-100px)] border-[#8D82B6] p-3 rounded-md">
        <MwCardWrapper>
          <form
            onSubmit={submitHandler}
            className="flex w-full flex-wrap mt-3  items-center gap-3"
          >
            <div className="w-36">
              <MwInputText
                invalid={errors?.start_date}
                // invalidMsg={errors?.start_date}
                inputType="date"
                label={t("reports.start_date")}
                value={expensesFormState?.start_date}
                onChange={(e) =>
                  setexpensesFormState({
                    ...expensesFormState,
                    start_date: e.target.value,
                  })
                }
                className="w-96"
              />
            </div>
            <div className="w-36">
              <MwInputText
                invalid={errors?.end_date}
                // invalidMsg={errors?.end_date}
                inputType="date"
                label={t("reports.end_date")}
                value={expensesFormState.end_date}
                onChange={(e) =>
                  setexpensesFormState({
                    ...expensesFormState,
                    end_date: e.target.value,
                  })
                }
                className="w-48"
              />
            </div>

            <div className="w-48">
              {
                <MwSelector
                  label={t("expenses.vendor")}
                  initalValue={t("invoice.selectVendor")}
                  dataType={"labelValue"}
                  _data={vendorsList}
                  withAddNew={false}
                  withSearch={false}
                  selectedItem={expensesFormState.vendor_id || ""}
                  setSelectedItem={(newValue) => {
                    setexpensesFormState({
                      ...expensesFormState,
                      vendor_id: newValue,
                    });
                  }}
                />
              }
            </div>
            <div className="flex-1">
              <TagList
                withLabel={true}
                label={t("Salaries.tags")}
                classNamePrivate="border border-[#8D82B6] border-opacity-55 outline-none"
                tagList={expensesFormState.tags}
                setTagList={(newValue) =>
                  setexpensesFormState({
                    ...expensesFormState,
                    tags: newValue,
                  })
                }
              />
            </div>
            <div className="flex-1">
              <MwInputText
                // invalid={errors?.seller_name}
                // invalidMsg={errors?.end_date}
                inputType="text"
                placeholder={t("reports.saller_name")}
                label={t("reports.saller_name")}
                value={expensesFormState.seller_name}
                onChange={(e) =>
                  setexpensesFormState({
                    ...expensesFormState,
                    seller_name: e.target.value,
                  })
                }
                className="w-48"
              />
            </div>
            <div className="mt-6">
              {!filterLoading ? (
                <NewButton
                  onClick={submitHandler}
                  type=""
                  classNameCustom="py-4 mt-1 border"
                >
                  {t("reports.repare")}
                </NewButton>
              ) : (
                <MwSpinnerButton />
              )}
            </div>
          </form>
        </MwCardWrapper>
        {!filterLoading && filterDataResult && (
          <MwCardWrapper id="Result">
            {filterDataResult?.data?.length > 0 ? (
              <>
                <div>
                  <div
                    ref={divPrintRef}
                    id="printable-area"
                    className="text-[#261759]  bg-[#F8FAFC] text-center"
                  >
                    <ExpensesReportsList data={filterDataResult} />
                  </div>
                </div>
              </>
            ) : (
              <div className=" h-[calc(100vh-293px)] ">
              <NoDataFound msg={t("reports.not_found")} />
              </div>             )}
          </MwCardWrapper>
        )}
      </div>
      {filterDataResult?.data?.length > 0 && (
        <div className="flex justify-end mt-2 px-3 py-2 bg-[#F8FAFC]">
          <div className="flex  gap-5">
            <div className="w-max">
              <NewButton
                onClick={exportPDF}
                className="flex items-center gap-1 hover:scale-105 font-bold transition-[0.9s]"
              >
                <FaFilePdf className="text-[#ffffff] me-1 text-[15px]" />
                <span className="text-sm text-[#ffffff] transition-[0.6s]">
                  {t("reports.pdf")}
                </span>
              </NewButton>
            </div>
            <div className="w-max">
              <NewButton onClick={exportExcel}>
                <LuDownload className="text-[#ffffff] me-1 text-[15px]" />{" "}
                <span className="text-sm text-[#ffffff] transition-[0.6s]">
                  {t("reports.excel")}
                </span>
              </NewButton>
            </div>
            <div className="w-max">
              <NewButton
                onClick={printHandler}
                className="flex items-center gap-1 hover:scale-105 font-bold transition-[0.9s]"
              >
                <LuPrinter className="text-[#f1f1f1] me-1 text-[15px]" />{" "}
                <span className="text-sm text-[#ffffff]  transition-[0.6s] ">
                  {t("reports.print")}
                </span>
              </NewButton>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpensesReport;
